import React, { memo, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setVehiculoUso, clearVehiculoUso } from "../actions";
import makeStyles from "@material-ui/styles/makeStyles";
import VehiculoUsoSelector from "~business/vehiculoUsoSelector/VehiculoUsoSelector";
import PrimaryTitle from "~styled/primaryTitle/PrimaryTitle";

const useStyles = makeStyles((theme) => ({
  cotizador: {
    flexDirection: "row",
    margin: "auto",
    padding: 20,
    paddingBottom: 100,
    maxWidth: 500,
    width: "100%",
    minHeight: "100vh",
  },
  title: {
    paddingBottom: "16px",
  },
}));

const useReduxSelector = () =>
  useSelector((state) => ({
    usoSelected: state.multicotizadorReducer.usoSelected,
  }));

const UsoStep = memo(() => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { usoSelected } = useReduxSelector();

  useEffect(() => {
    dispatch(clearVehiculoUso());
  }, [dispatch]);

  const handleChange = (event) => {
    dispatch(setVehiculoUso(event.target.value));
  };

  return (
    <>
      <div className={classes.cotizador}>
        <div className={classes.title}>
          <PrimaryTitle
            label="¿Cuál es el uso del vehículo?"
            marginBottom={32}
          />
        </div>
        <VehiculoUsoSelector value={usoSelected} onChange={handleChange} />
      </div>
    </>
  );
});

export default UsoStep;
